export const getRandomAd = (
  ads: { imageSrc: string; name: string; url: string }[]
) => {
  return ads[Math.floor(Math.random() * ads.length)]
}

const SIDEBAR_AD_BASE_URL = 'https://vinc.gumlet.io/gallery/sidebars/'

export const normalizeSidebarAdImageSrc = (imageSrc: string) => {
  const src = imageSrc.trim()

  if (!src) {
    return ''
  }

  try {
    const url = new URL(src, SIDEBAR_AD_BASE_URL)
    const pathParts = url.pathname.split('/').filter(Boolean)
    const fileName = pathParts[pathParts.length - 1]

    if (!fileName) {
      return src
    }

    url.protocol = 'https:'
    url.host = 'vinc.gumlet.io'
    url.pathname = `/gallery/sidebar/${fileName}`

    return url.toString()
  } catch {
    return src
  }
}
